export const CsvFileExtensions = ['csv'];
export const PfxFileExtensions = ['pfx'];
/** Image file extensions that are supported for Avatars by Central. */
export const AvatarImageFileExtensions = ['bmp', 'dib', 'gif', 'jfif', 'jpe', 'jpeg', 'jpg', 'pjp', 'pjpeg', 'png', 'svg'];
